export const REQUEST_NEWS_FETCH_AD = "REQUEST_NEWS_FETCH_AD";
export const FETCH_NEWS_AD_SUCCESS = "FETCH_NEWS_AD_SUCCESS";
export const FETCH_NEWS_AD_FAILURE = "FETCH_NEWS_AD_FAILURE";

export const CLEAR_FETCH_NEWS_AD_STATES = "CLEAR_FETCH_NEWS_AD_STATES";
